module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "part",
    attrs: {
      "id": "part1"
    }
  }, [_c('h1', {
    staticClass: "left"
  }, [_c('a', {
    attrs: {
      "id": "page8"
    }
  }), _c('a', {
    attrs: {
      "href": "#/004toc#part1"
    }
  }, [_vm._v(" SECTION 1: INTERIORS ")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("It’s no coincidence that the journey to modernity begins indoors. We spend our days at computers, our nights in front of the television, and though we may profess to be nature lovers, organic gardeners, and erstwhile outdoor hobbyists, the truth is that our lives are lived indoors, cocooned in the luxuries of the bourgeoisie—espresso machines, heated towel racks, and high-thread-count sheets.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Shunted from work to home and back, there is precious joy in cultivating our domestic surroundings. But navigating the vast sea of choices for modern living can be daunting. When your home space is so vital, there is no threshold for failure.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Precious few are fortunate enough to browse fittings and furnishings catalogs with the shrewd eye of an interior designer or the rigor of a minimalist architect, yet there is no remedy for the crippling embarrassment of purchasing a complete kitchen from a discount showroom. That’s where "), _c('em', [_vm._v("It’s Lonely in the Modern World")]), _vm._v(" comes in.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In this section, we reveal the choices, techniques, and materials that will create a vibrant modern home. It may require a bit more effort and study, but ultimately the DIY approach outlined here yields greater rewards. We’ll walk you through the elements of a well-appointed modern home. From the cold reflective surfaces of walls, floors, and countertops, to the high-end whirring appliances in your stainless-steel kitchen, to the best methods for illuminating a windowless room, you’ll learn how these elements combine to achieve the modern ideal.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Discover how to assemble the most mono of monochromatic color palettes, how to achieve the elusive open floor plan, and how a surfeit of design challenges can easily be solved with plywood. Soon you’ll be comfortable tossing around terms like “distressed” and “reclaimed.” Antique family heirlooms and tragic IKEA dorm decorations will give way to rooms filled with vintage and po-mo furniture, or, if you so choose, cavernous rooms filled with nothing at all. And should all else fail, you’ll learn how exposed ductwork can solve nearly any design flaw.")]), _vm._v(" "), _c('div', {
    staticClass: "image",
    attrs: {
      "id": "image1"
    }
  }, [_c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "id": "page9"
    }
  }), _c('img', {
    attrs: {
      "alt": "case study",
      "src": "images/image-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('strong', [_vm._v("CASE STUDY #196")])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("“Even the Eames stool understood that the only time he was awkwardly perched upon was when company came.”")])]), _vm._v(" "), _c('h2', {
    staticClass: "left"
  }, [_c('a', {
    attrs: {
      "id": "page10"
    }
  }), _vm._v("Form follows function.")]), _vm._v(" "), _c('h3', {
    staticClass: "left"
  }, [_vm._v(" LOUIS SULLIVAN (1856–1924) ")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The grandfather of modernism, the creator of the skyscraper, Frank Lloyd Wright’s mentor—this guy had it all. He coined “Form follows function,” which has become the anthem of architects worldwide. By the early 1900s, Sullivan’s work had fallen from fashion and he descended into a vicious spiral of alcoholism and financial trouble. He finished his career designing a series of small commercial banks in the Midwest before dying alone and destitute in a low-rent Chicago motel.")]), _vm._v(" "), _c('p', {
    staticClass: "white1"
  }), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('img', {
    attrs: {
      "alt": "arrow",
      "src": "images/image-2.jpg"
    }
  }), _vm._v(" "), _c('strong', [_vm._v("Notable Works: Nearly all of his skyscrapers were demolished. Only the banks remain.")])]), _vm._v(" "), _c('div', {
    staticClass: "image",
    attrs: {
      "id": "image3"
    }
  }, [_c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "id": "page11"
    }
  }), _c('img', {
    attrs: {
      "alt": "louis sullivan",
      "src": "images/image-3.jpg"
    }
  })])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-68df0439","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/007part1.vue
// module id = 72
// module chunks = 0